///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CustomerDTO, CustomerIdWithNameProjection } from '../../generated/shared-types.model';
import { Observable } from 'rxjs';

@Injectable()
export class GtthCustomerService {
    private readonly fetchUrl = 'api/customer';
    private readonly modifyUrl = 'api/customer';
    private readonly searchUrl = 'api/customer/search';

    constructor(private readonly http: HttpClient) {}

    create(customer: CustomerDTO): Observable<CustomerDTO> {
        return this.http.post<CustomerDTO>(this.modifyUrl, customer);
    }

    update(customer: CustomerDTO): Observable<CustomerDTO> {
        return this.http.put<CustomerDTO>(this.modifyUrl, customer);
    }

    blockCustomer(customer: CustomerDTO): Observable<CustomerDTO> {
        return this.http.put<CustomerDTO>(`${this.modifyUrl}/block`, customer);
    }

    find(id: number): Observable<CustomerDTO> {
        return this.http.get<CustomerDTO>(`${this.fetchUrl}/${id}`);
    }

    query(filter: string, baseUrl: string): Observable<CustomerDTO[]> {
        let requestUrl: string;
        if (baseUrl === 'customers') {
            requestUrl = `${this.searchUrl}/user-companies`;
        } else {
            requestUrl = `${this.searchUrl}/project-companies`;
        }

        let params: HttpParams = new HttpParams();
        if (filter) {
            params = params.set('filter', filter);
        }

        return this.http.get<CustomerDTO[]>(requestUrl, { params });
    }

    getLightListForParent(): Observable<CustomerIdWithNameProjection[]> {
        return this.http.get<CustomerIdWithNameProjection[]>(`${this.fetchUrl}/light-list-parents`);
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.modifyUrl}/${id}`);
    }
}
